import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
export function ImpressumPage() {
  return <div className="min-h-screen bg-white font-sans text-slate-900 selection:bg-[#59d0d4]/30 selection:text-[#3b7780] flex flex-col" data-id="element-576">
      <Navbar data-id="element-577" />
      <main className="flex-grow pt-32 pb-20 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto w-full" data-id="element-578">
        <h1 className="text-3xl md:text-5xl font-extrabold text-slate-900 mb-10 tracking-tight" data-id="element-579">
          Impressum
        </h1>

        <div className="prose prose-slate max-w-none space-y-8" data-id="element-580">
          <section data-id="element-581">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-582">
              Angaben gemäß § 5 TMG
            </h2>
            <p className="text-slate-600 leading-relaxed" data-id="element-583">
              <strong data-id="element-584">2N Kurse GbR Dres. Schwenk, Striegel, Herzog</strong>
              <br data-id="element-585" />
              Ludwigsplatz 1a
              <br data-id="element-586" />
              90403 Nürnberg
            </p>
          </section>

          <section data-id="element-587">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-588">Kontakt</h2>
            <p className="text-slate-600 leading-relaxed" data-id="element-589">
              Telefon: 0911 – 56836360
              <br data-id="element-590" />
              E-Mail: info@2n-fortbildung.de
            </p>
          </section>

          <section data-id="element-591">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-592">
              Vertreten durch
            </h2>
            <p className="text-slate-600 leading-relaxed" data-id="element-593">
              Dr. Thomas Schwenk
              <br data-id="element-594" />
              Dr. Markus Striegel
              <br data-id="element-595" />
              Dr. Johanna Herzog
            </p>
          </section>
        </div>
      </main>
      <Footer data-id="element-596" />
    </div>;
}